import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import {
  mediaItemFallbackContainer,
  mediaItemFallbackLabel,
} from '@/components/post-card/post-card-media/post-card-media-item-fallback.css.ts';

export const PostCardMediaFallback = ({ label }: { label?: string }) => (
  <div
    className={mediaItemFallbackContainer}
    onClick={(e) => e.preventDefault()}
  >
    <div className={mediaItemFallbackLabel}>{label}</div>
    <Skeleton width={'100%'} height={'100%'} />
  </div>
);
